import React from "react";
import item1 from "../assets/ads/item1.png";
import item2 from "../assets/ads/item2.png";
import left from "../assets/ads/left.png";
import right from "../assets/ads/right.png";

const AboutUs = () => {
  return (
    <section className="relative bg-white py-20 px-6 overflow-hidden select-none min-h-[460px] flex items-center justify-center">
      {/* LEFT Dining block with overlapping plate (item1) */}
      <div className="absolute left-[-120px] lg:left-[-160px] top-1/2 -translate-y-1/2 w-[340px] h-[340px] lg:w-[440px] lg:h-[440px] z-10 hidden md:block">
        {/* Background Circle */}
        <div className="w-full h-full rounded-full overflow-hidden border-8 border-white shadow-[0_8px_30px_rgba(0,0,0,0.12)] group">
          <img
            src={left}
            alt="Left Dining Scene"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
        </div>
        {/* Floating Plate (item1) with 3D overlap */}
        <img
          src={item1}
          alt="Steak Pasta Plate"
          className="absolute right-[-40px] lg:right-[-65px] top-[40%] -translate-y-1/2 w-[180px] h-[180px] lg:w-[260px] lg:h-[260px] z-20 transition-transform duration-500 hover:scale-105 hover:rotate-[6deg] drop-shadow-[0_15px_15px_rgba(0,0,0,0.18)]"
        />
      </div>

      {/* RIGHT Dining block with overlapping plate (item2) */}
      <div className="absolute right-[-120px] lg:right-[-160px] top-1/2 -translate-y-1/2 w-[340px] h-[340px] lg:w-[440px] lg:h-[440px] z-10 hidden md:block">
        {/* Background Circle */}
        <div className="w-full h-full rounded-full overflow-hidden border-8 border-white shadow-[0_8px_30px_rgba(0,0,0,0.12)] group">
          <img
            src={right}
            alt="Right Dining Scene"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
        </div>
        {/* Floating Plate (item2) with 3D overlap */}
        <img
          src={item2}
          alt="Squid Ink Pasta Plate"
          className="absolute left-[-40px] lg:left-[-65px] top-[40%] -translate-y-1/2 w-[180px] h-[180px] lg:w-[260px] lg:h-[260px] z-20 transition-transform duration-500 hover:scale-105 hover:rotate-[-6deg] drop-shadow-[0_15px_15px_rgba(0,0,0,0.18)]"
        />
      </div>

      {/* SCATTERED FOOD DOODLES (Line Art SVGs) */}
      {/* Onion (Top-Left) */}
      <div className="absolute left-[33%] top-[15%] w-10 h-10 text-gray-200 opacity-60 pointer-events-none hidden lg:block">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1"
          className="w-full h-full"
        >
          <circle cx="12" cy="12" r="9" />
          <path d="M12 3 C12 7, 7 12, 3 12 M12 21 C12 17, 17 12, 21 12 M12 3 A9 9 0 0 1 21 12" />
        </svg>
      </div>

      {/* Garlic (Top-Left near onion) */}
      <div className="absolute left-[26%] top-[25%] w-8 h-8 text-gray-200 opacity-60 pointer-events-none hidden lg:block">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          className="w-full h-full"
        >
          <path d="M12 2 Q10 7 7 12 Q5 16 7 20 C10 22, 14 22, 17 20 Q19 16 17 12 Q14 7 12 2 Z" />
          <path d="M12 2 V22 M9 5 Q12 12 9 20 M15 5 Q12 12 15 20" />
        </svg>
      </div>

      {/* Mushroom (Bottom-Left) */}
      <div className="absolute left-[28%] bottom-[15%] w-7 h-7 text-gray-200 opacity-60 pointer-events-none hidden lg:block">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          className="w-full h-full"
        >
          <path d="M4 12 C4 6, 20 6, 20 12 L16 12 C16 15, 14 17, 14 20 L10 20 C10 17, 8 15, 8 12 Z" />
          <line x1="12" y1="12" x2="12" y2="20" />
        </svg>
      </div>

      {/* Farfalle Pasta (Bottom-Right) */}
      <div className="absolute right-[28%] bottom-[18%] w-10 h-10 text-gray-200 opacity-60 pointer-events-none hidden lg:block">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1"
          className="w-full h-full"
        >
          <path d="M3 6 L6 10 L3 14 L8 14 L12 11 L16 14 L21 14 L18 10 L21 6 L16 6 L12 9 L8 6 Z" />
          <path d="M12 9 C11 10, 11 11, 12 11 M12 9 C13 10, 13 11, 12 11" />
        </svg>
      </div>

      {/* Tomato Slice (Bottom-Right near pasta) */}
      <div className="absolute right-[33%] bottom-[8%] w-8 h-8 text-gray-200 opacity-60 pointer-events-none hidden lg:block">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1"
          className="w-full h-full"
        >
          <circle cx="12" cy="12" r="9" />
          <circle cx="12" cy="12" r="7" strokeDasharray="2,2" />
          <circle cx="9" cy="9" r="1" fill="currentColor" />
          <circle cx="15" cy="9" r="1" fill="currentColor" />
          <circle cx="9" cy="15" r="1" fill="currentColor" />
          <circle cx="15" cy="15" r="1" fill="currentColor" />
        </svg>
      </div>

      {/* CENTER CONTENT */}
      <div className="max-w-2xl mx-auto text-center z-20 px-6 flex flex-col items-center">
        {/* About Us Badge */}
        <div className="inline-flex items-center gap-2 bg-orange-50 px-3 py-1 rounded-full border border-orange-100">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="w-4 h-4 text-[#f25e1c]"
          >
            <path d="M12 5V3M10 3h4" />
            <path d="M4 14a8 8 0 0 1 16 0" />
            <path d="M2 15h20" />
          </svg>
          <span className="text-[#f25e1c] font-black tracking-widest text-[10px] uppercase font-mono">
            ABOUT US
          </span>
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="w-4 h-4 text-[#f25e1c]"
          >
            <path d="M12 5V3M10 3h4" />
            <path d="M4 14a8 8 0 0 1 16 0" />
            <path d="M2 15h20" />
          </svg>
        </div>

        {/* Title */}
        <h2 className="text-3xl md:text-4xl lg:text-[40px] font-extrabold text-slate-900 mt-4 leading-tight tracking-tight font-sans">
          Variety Of Flavours From
          <br />
          American Cuisine
        </h2>

        {/* Description Paragraph */}
        <p className="text-xs md:text-sm text-gray-400 mt-5 leading-relaxed font-sans max-w-lg">
          It is a long established fact that a reader will be distracted the
          readable content of a page when looking at layout the point
          established fact that
        </p>

        {/* Order Now Button with box arrow */}
        <div className="mt-8">
          <a
            href="#menu"
            className="flex items-center bg-[#d82c0d] hover:bg-[#b5240a] text-white font-sans text-[11px] font-black tracking-widest h-12 pl-6 rounded transition-all duration-300 overflow-hidden shadow-md group/btn"
          >
            <span className="mr-5 uppercase">ORDER NOW</span>
            <div className="bg-white text-[#d82c0d] w-12 h-12 flex items-center justify-center transition-colors duration-300 group-hover/btn:bg-[#f5a623] group-hover/btn:text-neutral-900 border-l border-white">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                className="w-3.5 h-3.5"
              >
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
